export const fieldLabels = {
  caseTitle: "Case title",

  referenceCheck: "Reference Check",
  FeedbackToCitizen: "Rejected reason",
  partiallyapproverejectedReason: "Partially Approved/Rejected Reason",
  adminRejectedReason: "Admin rejected reason (RTW, References)",
  feedbackToCitizen: "Feedback to citizen"
};
